import React from 'react';

import FormContextProvider, { FormContext } from '../../../../Context/FormContext';
import Utils from '../../../../Services/Utils';

function withFieldActions(WrappedComponent) {
  return class extends React.PureComponent {
    constructor(props) {
      super(props);
      this.state = {
        internalField: {
          ...this.props.field,
          options: this.props.field.options ? [...Utils.setNewPointersOfDicsInArray(this.props.field.options)] : [],
        },
        currentTab: 0,
        currentConditionView: 0,
        currentTriggerView: 0,
        currentCondition: null,
        currentRule: null,
        currentTrigger: null,
        submitted: false,
        oldCondition: null
      };
      this.editingIndex = -1;
      this.pmsPlatforms = this.props.pmsPlatforms;
      this.chargesCodes = this.props.chargeCodes;
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.field !== this.props.field) {
        this.setState({
          internalField: {
            ...nextProps.field,
            options: nextProps.field.options ? [...Utils.setNewPointersOfDicsInArray(nextProps.field.options)] : [],
          },
        });
      }
    }

    handleSubmit = () => {
      const { api, field } = this.props;
      const { internalField } = this.state;
      const changeInverseConditions = internalField.label !== field.label ;
      const changeInverseConditionsOptions = JSON.stringify(internalField.options) !== JSON.stringify(field.options);
      const oldOptions = field.options ? [...field.options].map((option) => {return option.value}) : [];
      api.onFieldValueChange(field.id, field.section, internalField, (changeInverseConditions || changeInverseConditionsOptions), oldOptions);
      field.changeValues(internalField);
      this.setState({
        internalField: {
          ...internalField,
          options: internalField.options ? [...Utils.setNewPointersOfDicsInArray(internalField.options)] : [],
        },
      });
      return true;
    };

    handleDelete = () => {
      const { api, indexInSection } = this.props;
      const { internalField } = this.state;
      api.onRemoveField(indexInSection, internalField.section);
    };

    handleCancel = () => {
      const { field } = this.props;
      this.setState({
        internalField: {
          ...field,
          errors: [],
          options: field.options ? [...Utils.setNewPointersOfDicsInArray(field.options)] : [],
        },
      });
    };

    handleClone = () => {
      const { api, indexInSection } = this.props;
      const { internalField } = this.state;
      api.onCloneField(internalField, indexInSection);
    };

    changeFieldValue = (field, value) => {
      const { internalField } = this.state;
      internalField[field] = value;
      this.setState({
        internalField: { ...internalField },
      });
    };

    changeFieldErrors = (field, error) => {
      const { internalField } = this.state;
      internalField.errors[field] = error;
      this.setState({
        internalField: { ...internalField },
      });
    };

    setLocaleValuesonDefaultParameters = () => {
      const {internalField} = this.state
      let fieldArray = ['label', 'description', 'placeholder', 'options']
      const {api} = this.props
      fieldArray.forEach(field_name =>{
        if((internalField[field_name] && !angular.isArray(internalField[field_name])) || (angular.isArray(internalField[field_name]) && internalField[field_name].length > 0)){
          if(field_name != 'options'){
            internalField[field_name] = api.getFieldsVerbiage(internalField, field_name);
          }
          else {
            let options = api.getFieldsVerbiage(internalField, field_name);
            for(let i = 0; i < internalField[field_name].length; i++){
              internalField[field_name][i].value = options[i].label ? options[i].label : options[i].value;
            }
          }
          
        }
      })
    };

    renderForm = (renderConfig) => {
      const { internalField } = this.state;
      return renderConfig(internalField, this.changeFieldValue, this.changeFieldErrors);
    };

    render() {
      const { internalField } = this.state;
      return (
        <FormContextProvider>
          <FormContext.Consumer>
            { context => (
              <WrappedComponent
                { ...this.props }
                { ...this.state }
                internalField={ internalField }
                changeFieldValue={ this.changeFieldValue }
                changeFieldErrors={ this.changeFieldErrors }
                renderForm={ this.renderForm }
                handleCancel={ () => context.cancel(this.handleCancel) }
                handleDelete={ this.handleDelete }
                handleSubmit={ () => context.submit(this.handleSubmit, internalField.errors) }
                handleClone={ this.handleClone }
                setLocaleValuesonDefaultParameters = {this.setLocaleValuesonDefaultParameters}
              />
            ) }
          </FormContext.Consumer>
        </FormContextProvider>
      );
    }
  };

}

export default withFieldActions;